import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Avatar from "@mui/material/Avatar"
import { MONO, CHAT_COLOR } from "../constants"

export function MemberPicker({ users, me, selected, onToggle }) {
  return (
    <>
      {users.filter(u => u.username !== me).map(u => {
        const on = selected.has(u.username)
        return (
          <Box key={u.username} onClick={() => onToggle(u.username)}
            sx={{ display: "flex", alignItems: "center", gap: 1, px: 1.25, py: 0.6,
              borderRadius: 1, mb: 0.4, cursor: "pointer",
              backgroundColor: on ? "rgba(245,158,11,0.1)" : "rgba(var(--app-fg-rgb),0.03)",
              border: "1px solid " + (on ? "rgba(245,158,11,0.3)" : "rgba(var(--app-fg-rgb),0.05)"),
              "&:hover": { borderColor: "rgba(245,158,11,0.25)" } }}>
            {u.avatar_b64
              ? <Avatar src={u.avatar_b64} sx={{ width: 18, height: 18, flexShrink: 0 }} />
              : <Avatar sx={{ width: 18, height: 18, flexShrink: 0, bgcolor: "rgba(var(--app-fg-rgb),0.06)", fontSize: 9 }}>
                  {(u.display_name ?? u.username)[0]?.toUpperCase()}
                </Avatar>}
            <Typography sx={{ flex: 1, fontFamily: MONO, fontSize: "0.71rem",
              color: u.name_color ?? "rgba(var(--app-fg-rgb),0.82)",
              overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {u.display_name ?? u.username}
            </Typography>
            <Typography sx={{ fontFamily: MONO, fontSize: "0.7rem", color: on ? CHAT_COLOR : "rgba(var(--app-fg-rgb),0.25)" }}>
              {on ? "✓" : "+"}
            </Typography>
          </Box>
        )
      })}
    </>
  )
}
